"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatePaymentDetailsPopup = exports.resetPaymentDetailsPopupState = exports.popupSlice = exports.default = exports.PAYMENT_DETAILS_STEPS = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toolkit = require("@reduxjs/toolkit");
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var PAYMENT_DETAILS_STEPS = {
  PAYMENT_DETAILS_UPDATE: 'PAYMENT_DETAILS_UPDATE',
  DELETE_PAYMENT_DETAILS: 'DELETE_PAYMENT_DETAILS',
  FINALIZE_ADYEN: 'FINALIZE_ADYEN',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR'
};
exports.PAYMENT_DETAILS_STEPS = PAYMENT_DETAILS_STEPS;
var initialState = {
  paymentDetails: {
    isOpen: false,
    isLoading: false,
    step: PAYMENT_DETAILS_STEPS.PAYMENT_DETAILS_UPDATE,
    initPaymentMethod: null
  }
};
var popupSlice = (0, _toolkit.createSlice)({
  name: 'popupManager',
  initialState: initialState,
  reducers: {
    updatePaymentDetailsPopup: function updatePaymentDetailsPopup(state, _ref) {
      var payload = _ref.payload;
      state.paymentDetails = _objectSpread(_objectSpread({}, state.paymentDetails), payload);
    },
    resetPaymentDetailsPopupState: function resetPaymentDetailsPopupState(state) {
      state.paymentDetails = initialState.paymentDetails;
    }
  },
  extraReducers: {}
});
exports.popupSlice = popupSlice;
var _popupSlice$actions = popupSlice.actions,
  updatePaymentDetailsPopup = _popupSlice$actions.updatePaymentDetailsPopup,
  resetPaymentDetailsPopupState = _popupSlice$actions.resetPaymentDetailsPopupState;
exports.resetPaymentDetailsPopupState = resetPaymentDetailsPopupState;
exports.updatePaymentDetailsPopup = updatePaymentDetailsPopup;
var _default = popupSlice.reducer;
exports.default = _default;